import { useState } from 'react'
import { Flex } from 'antd'
import { Image } from 'react-bootstrap'
import ClassName from 'clsx'
import useLang from '@/utils/hooks/use-lang'
import Icon from '@/components/icon'
import PageWrapper from '@/components/page-wrapper'
import Banner from './banner'
import Info from './info'
import Epc from './epc'
import TimeLine from '@/components/time-line'
import HorizontalScroll from '@/components/horizon-list'
import SwiperComponent from '@/components/swiper-intro'
import { i18nAboutUs, type AboutUsProps } from '@/assets/content/about-us'
import earthGrayImg from '@/assets/img/about-us/earth-gray.png'
import { news as newList } from './news-data'
import Styles from './style.module.scss'

export default function Index() {
  const [historyActiveIndex, setHistoryActiveIndex] = useState(0)
  const [lang] = useLang()
  const { history, teamMember, valued, services, models } = i18nAboutUs[lang] as AboutUsProps

  return (
    <PageWrapper>
      <Banner />
      <Info />
      <Epc />
      <Flex
        vertical
        align='center'
        className={Styles.historyWrapper}
        style={{ background: `#fff url(${earthGrayImg}) no-repeat center bottom/contain` }}
      >
        <h2>{history.title}</h2>
        <Flex align='center'>
          <TimeLine items={history.timeline} onChange={setHistoryActiveIndex} />
          <div
            dangerouslySetInnerHTML={{ __html: history.timeline[historyActiveIndex].content }}
            className={Styles.content}
          />
        </Flex>
      </Flex>
      <Flex vertical className={Styles.contentWrapper}>
        <div className={Styles.teamWrapper}>
          <Flex vertical align='center' className={Styles.top}>
            <h2>{teamMember.title}</h2>
            <div>{teamMember.description}</div>
          </Flex>
          <div className={Styles.teamMember}>
            <SwiperComponent data={teamMember.list} />
          </div>
        </div>
        {/* <Flex vertical className={Styles.news}>
          <h2>news & blog </h2>
          {!!newList?.length && (
            <HorizontalScroll itemsPerScreen={4} gap={32}>
              {newList.map(item => (
                <div key={item.id} className={Styles.newsItem}>
                  <Image src={item.image} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                  <div className={Styles.content}>
                    <div className={Styles.title} onClick={() => window.open(item.link)}>
                      {item.title}
                    </div>
                    <div className={Styles.date}>{item.date}</div>
                  </div>
                </div>
              ))}
            </HorizontalScroll>
          )}
        </Flex>

        <Flex vertical className={Styles.valued}>
          <div className={Styles.header}>
            <h2>{valued.title}</h2>
            <div className={Styles.subtitle}>{valued.description}</div>
          </div>
          <div className={Styles.valuedList}>
            {valued.list.map((d, index) => (
              <Flex vertical key={index} className={Styles.item}>
                <div className={Styles.index}>{`${index + 1}`.length < 2 ? `0${index + 1}` : index + 1}</div>
                <h6>{d.title}</h6>
                <div className={Styles.description}>{d.description}</div>
              </Flex>
            ))}
          </div>
        </Flex>

        <Flex vertical align='center' className={Styles.services}>
          <h4>{services.title}</h4>
          <Flex className={Styles.servicesList}>
            {services.list.map(d => (
              <Flex
                key={d.title}
                vertical
                justify='flex-end'
                className={Styles.item}
                style={{ background: `url(${d.image}) no-repeat center/cover` }}
              >
                <div className={Styles.title}>{d.title}</div>
                <div className={Styles.description}>{d.description}</div>
              </Flex>
            ))}
          </Flex>
        </Flex>

        <Flex vertical className={ClassName(Styles.models)}>
          <h4>{models.title}</h4>
          <div className={Styles.gridList}>
            {models.list.map(({ icon, title, contents }) => (
              <Flex key={title} vertical align='flex-start' className={Styles.gridItem}>
                <Icon name={icon} className={Styles.icon} />
                <div className={Styles.title}>{title}</div>
                <ul>
                  {contents.map(text => (
                    <li key={text}>{text}</li>
                  ))}
                </ul>
              </Flex>
            ))}
          </div>
        </Flex> */}
      </Flex>
    </PageWrapper>
  )
}
